import { Helmet } from "react-helmet"
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion"
import "react-accessible-accordion/dist/fancy-example.css"

export const currentPath = window.location.pathname
export const currentDomain = window.location.origin

export default function TNC() {
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>FGH - Terms & Condition</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta
          name="description"
          content="Read FGH Casino’s Terms & Conditions for secure online play in the Philippines. Covers account rules, deposits, withdrawals, rollover policy & player obligations. 21+."
        />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>

      <div className="main-body-content main-container-global-adjusted-padding tnc-page">
        <h1 className="fgh-h1-style">Terms & Conditions</h1>
        <p>
          All betting information supplied by FGH is administered in good faith.
          Please take a moment to read carefully. The following are the Terms
          and Conditions governing the use of this website and the services
          provided by Fun Gaming Hub (FGH). By accessing any page of this
          website and/or using the services, the customer agrees to be bound by
          these Terms and Conditions without limitation or qualification. If the
          customer does not accept these Terms and Conditions, do not attempt to
          use or continue using any of the services immediately. We reserve the
          right to change the Terms and Conditions without prior notice.
        </p>
        <Accordion preExpanded={["a"]}>
          {" "}
          <AccordionItem uuid="a">
            <AccordionItemHeading>
              <AccordionItemButton>General</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p>
                This end user agreement (the “Agreement”) should be read by you
                (the “User” or “You”) in its entirety prior to your use of FGH’s
                service or products. Please note that the Agreement constitutes
                a legally binding agreement between you and FGH.
              </p>
              <p>
                These Terms and Conditions come into force as soon as you
                complete the registration process, which includes checking the
                box accepting these Terms and Conditions and successfully
                creating an account. By using any part of the Website following
                account creation, you agree to these Terms and Conditions
                applying to the use of the Website.
              </p>
              <p>
                You must read these Terms and Conditions carefully in their
                entirety before creating an account. If you do not agree with
                any provision of these Terms and Conditions, you must not create
                an account or continue to use the Website.
              </p>
              <p>
                We reserve the right to make amendments to these Terms and
                Conditions at any time and without advanced notice. If we make
                such amendments, we may take appropriate steps to bring such
                changes to your attention (such as by email or placing a notice
                on a prominent position on the Website, together with the
                amended terms and conditions) but it shall be your sole
                responsibility to check for any amendments, updates and/or
                modifications. Your continued use of fgh one services and
                Website after any such amendment to the Terms and Conditions
                will be deemed as your acceptance and agreement to be bound by
                such amendments, updates and/or modifications.
              </p>
              <p>
                By clicking the “I Agree” button if and where provided and/or
                using the Service, you consent to the terms and conditions set
                forth in this Agreement.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Deposit Policy</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p>
                Our payment details and deposit steps are available on our
                website once you login under the WALLET BUTTON. If you need
                help, please contact us via Telegram (https://t.me/FUNGAMINGHUB)
                and one of our FGH customer support representatives will assist
                you.
              </p>
              <p>
                We have a minimum deposit of PHP 200, and you may also deposit
                straight in our official VIBER/TELEGRAM accounts. Make
                sure to confirm our contact using our website’s livechat.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Withdrawal Policy</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p>
                Members are required to complete a 1x rollover (stake) of their
                deposit before withdrawal. Members cannot have the same bank
                account name / number with our existing players.
              </p>
              <p>Example:</p>

              <ul className="fgh-accordion-list">
                <li>A member deposited 1,000 PHP.</li>
                <li>
                  The member is required to place 1,000 PHP worth of total bets
                  in any of our online casino games.
                </li>
                <li>
                  All rounds will be counted as your turnover thus you would not
                  have to worry in completing your 1x rollover
                </li>
                <li>
                  Players can always check with our customer support if they are
                  able to withdraw their balance after depositing any amount and
                  placing bets.
                </li>
                <li>
                  Players can also check their turnover & win-loss under “Game
                  report” which is in the “Activity Page”.
                </li>
                <li>
                  We provide real time processing of your withdrawal. For
                  maximum withdrawal limit please contact our customer support
                  for more information.
                </li>
                <li>
                  Once a withdrawal request is submitted please contact our
                  customer support to check your request and give us some time
                  to process it for you.
                </li>
                <li>
                  You can only use bank accounts that are under your name for
                  withdrawal – others would be subject to approval.
                </li>
                <li>
                  There will be a 25 PHP and 100 PHP Service Charge per
                  withdrawal request if your bank account is under INSTAPAY and
                  PESONET respectively.
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Share Credits Policy</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <p>
                You are required to clear all your rollover requirements before
                being eligible to file a Share Credits Request. The receiver
                will also be required to complete a 1x rollover requirement of
                the amount they receive before withdrawal.
              </p>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Player Obligations</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="fgh-accordion-list">
                <li>
                  Prior to your use of the Service and on an ongoing basis, you
                  represent, warrant, covenant and agree that.
                </li>
                <li>
                  You are over 21 or such other legal age of majority as
                  determined by any laws which are applicable to you, whichever
                  age is greater.
                </li>
                <li>
                  You have full capacity to enter into a legally binding
                  agreement with us and you are not restricted by any form of
                  limited legal capacity.
                </li>
                <li>
                  You are not diagnosed or classified as a compulsive or problem
                  gambler.
                </li>
                <li>
                  You are accessing fgh.fun from a jurisdiction in which it is
                  legal to do so.
                </li>
                <li>
                  All information that you provide to us during the term of
                  validity of this agreement is true, complete and correct, and
                  that you shall immediately notify us of any change of such
                  information.
                </li>
                <li>
                  You will not use our services while located in any
                  jurisdiction that prohibits the placing and/or accepting of
                  bets online and/or playing casino and/or live games and/or
                  sportsbook.
                </li>
                <li>
                  Your use of the Service is at your sole option, discretion and
                  risk.
                </li>
                <li>
                  You participate in the Games on your own behalf and not on the
                  behalf of any other person.
                </li>
                <li>
                  You are solely responsible for reporting and accounting for
                  any taxes applicable to you under relevant laws for any
                  winnings that you receive from us.
                </li>
                <li>
                  There is a risk of losing money when using the Service and FGH
                  is not responsible for your losses.
                </li>
                <li>
                  In relation to deposits and withdrawals of funds into and from
                  your FGH Account, you shall only use currency that is valid
                  and lawfully belongs to you.
                </li>
                <li>
                  You only have one account with us and agree not to open
                  multiple accounts with us.
                </li>
                <li>
                  You acknowledge and accept that we reserve the right to detect
                  and prevent the use of prohibited techniques, including but
                  not limited to fraudulent transaction detection, automated
                  registration and signup, gameplay and screen capture
                  techniques. These steps may include, but are not limited to,
                  examination of Players device properties, detection of
                  geo-location and IP masking, transactions and blockchain
                  analysis.
                </li>
                <li>
                  The telecommunications networks and Internet access services
                  required for you to access and use the Service are entirely
                  beyond the control of FGH and FGH shall have no liability
                  whatsoever for any outages, slowness, capacity constraints or
                  other deficiencies affecting the same.
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Bonuses and Promos</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <ul className="fgh-accordion-list">
                <li>
                  FGH, at its sole discretion, might offer from time to time a
                  number of Bonuses and Promotions.
                </li>
                <li>
                  Each of the Bonuses and Promotions has its own set of terms
                  and conditions and individual requirements if any. By
                  partaking in a bonus or promotion, you are automatically
                  agreeing to the applicable terms and conditions.
                </li>
                <li>
                  FGH reserves the right to remove bonus credits from all
                  inactive accounts or accounts that are identified as
                  “promotional hunters”.
                </li>
                <li>
                  FGH reserves the right to cancel all bonuses that have not
                  been claimed within the claiming period or 60 days, the
                  shorter of the two.
                </li>
                <li>
                  FGH reserves the right to cancel any bonus or promotions at
                  its sole description.
                </li>
              </ul>
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </div>
    </>
  )
}
